import { useEffect, useState } from 'react'
import { api } from '../../api/client'
import TextDocument from './TextDocument'
export default function Prompts() {
  const [data, setData] = useState<Awaited<ReturnType<typeof api.promptTemplates>> | null>(null)
  const [selected, setSelected] = useState('research')
  const [error, setError] = useState('')
  useEffect(() => { let live = true; api.promptTemplates().then(value => { if (live) setData(value) }).catch(e => { if (live) setError(e.message) }); return () => { live = false } }, [])
  const template = data?.templates.find(row => row.id === selected)
  return <><div className="app-head"><h1>Prompt templates</h1></div>
    <p className="muted">Choose a stage to inspect its exact template. Company-specific inputs and generated outputs are in company Diagnostics.</p>
    {error && <p className="notice crit" role="alert">{error}</p>}
    {!data && !error && <p>Loading templates…</p>}
    {data && <div className="template-workspace"><nav aria-label="Prompt stages">{data.templates.map(row => <button key={row.id} aria-current={selected === row.id ? 'true' : undefined} onClick={() => setSelected(row.id)}>{row.name}</button>)}</nav>
      {template && <section className="template-detail"><h2>{template.name}</h2><p className="muted">{template.description}</p>
        <TextDocument label="Exact system prompt" text={template.system_template} code />
        <TextDocument label="Exact input template" text={template.input_template} code />
        <p className="muted">Company data replaces these placeholders: {template.variables.map(variable => <code key={variable}>{`{${variable}} `}</code>)}</p>
      </section>}
    </div>}
  </>
}
